var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderKp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.787,
    height: 16.013,
    viewBox: "0 0 12.787 16.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.317 -0.191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.422,16.013h0c-.053-.041-5.262-4.176-6.157-7.8a6.394,6.394,0,1,1,12.421-.689l.015,0c-.18,1.982-1.878,4.184-3.27,5.681a29.338,29.338,0,0,1-3.008,2.8ZM6.481,2.586A2.616,2.616,0,1,0,9.1,5.2,2.619,2.619,0,0,0,6.481,2.586Z",
    transform: "translate(0.317 0.191)",
    fill: "#a8a8a8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderKp);
export default __webpack_public_path__ + "static/media/placeholder_kp.1a2b2aec45d345a0cabc44ae45aad02b.svg";
export { ForwardRef as ReactComponent };